import { inject, onBeforeUnmount, watch } from "vue";

export const modalBusyOwner = Symbol("modalBusyOwner");

// A reused form can protect its enclosing shell without moving mutation state
// into each page. Each child owns a token, so concurrent work cannot unlock it.
export function useModalBusy(source) {
    const owner = inject(modalBusyOwner, null);
    if (!owner) return;
    const token = Symbol("modalTask");
    watch(source, (busy) => owner(token, Boolean(busy)), { immediate: true, flush: "sync" });
    onBeforeUnmount(() => owner(token, false));
}

export function modalBusyMixin(fields) {
    return {
        inject: { enclosingModalBusy: { from: modalBusyOwner, default: null } },
        created() {
            const token = Symbol("modalTask");
            const stop = this.$watch(
                () => fields.some((field) => Boolean(this[field])),
                (busy) => this.enclosingModalBusy?.(token, busy),
                { immediate: true, flush: "sync" }
            );
            this.releaseModalBusy = () => {
                stop();
                this.enclosingModalBusy?.(token, false);
            };
        },
        beforeUnmount() { this.releaseModalBusy?.(); }
    };
}
